import { Injectable } from '@angular/core';
import { HelpWalkthroughStep } from '../models/help-api.types';

/** Extension point for future analytics; v1 no-op. */
export abstract class HelpWalkthroughAnalyticsPort {
  abstract tourStarted(walkthroughName: string, step: HelpWalkthroughStep, index: number): void;
  abstract tourFinished(walkthroughName: string): void;
  abstract tourAborted(walkthroughName: string, index: number): void;
}

@Injectable({ providedIn: 'root' })
export class HelpWalkthroughAnalyticsNoopService extends HelpWalkthroughAnalyticsPort {
  tourStarted(_walkthroughName: string, _step: HelpWalkthroughStep, _index: number): void {}
  tourFinished(_walkthroughName: string): void {}
  tourAborted(_walkthroughName: string, _index: number): void {}
}
